import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { AppBar, Box, Grid, Menu, MenuItem } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import notificationlogo from "@/assets/inactiveNotification.svg";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { AccountCircle } from "@material-ui/icons";
import { useAuth } from "@/lib/auth";
import dropdownIcon from "@/assets/dropdownIcon.svg";
import world from "@/assets/world.svg";
import yellowt from "@/assets/yellow-t.png";
import wallet from "@/assets/wallet.svg";
import MenuIcon from "@mui/icons-material/Menu";
import logoCrypto from "@/assets/logoCrypto.png";
import slogan from "@/assets/sloganCrypto.png";
import "../../../src/components/Elements/CSS/header.css";
import "../../../src/components/Elements/CSS/style.css";
import NotificationPopup from "./notification";
import Swal from "sweetalert2";
import { useWalletAmount } from "./api/getWalletamount";
import MervIcon from "../../assets/userIcon.png";
import CurrencyFormat from "react-currency-format";
import { theme } from "./theme";
import Drawer from "@mui/material/Drawer";
import DehazeRoundedIcon from "@mui/icons-material/DehazeRounded";
import { lastDayOfDecade } from "date-fns";
// import Notifications from "./notification";
declare global {
  interface Window {
    // ⚠️ notice that "Window" is capitalized here
    google: any;
    googleTranslateElementInit: any;
  }
}
type HeaderProps = {
  isSticky?: boolean;
};
export default function Header({ isSticky }: HeaderProps) {
  const [showSelector, setShowSelector] = React.useState(false);
  const { logout } = useAuth();
  const dataWallet = useWalletAmount({});
  console.log(dataWallet?.data?.userImage , "abhay")
  const googleTranslateElementInit = () => {
    if (!document.getElementById("google_translate_placeholder")) {
      const placeholder = document.createElement("div");
      placeholder.id = "google_translate_placeholder";
      document
        .getElementById("google_translate_element")
        ?.appendChild(placeholder);

      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          layout:
            window.google.translate.TranslateElement.InlineLayout.VERTICAL,
          autoDisplay: false,
        },
        "google_translate_placeholder"
      );
    }
  };

  React.useEffect(() => {
    const savedLang = localStorage.getItem("preferredLang");

    if (!document.querySelector("script[src*='translate_a/element.js']")) {
      const addScript = document.createElement("script");
      addScript.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      document.body.appendChild(addScript);
      (window as any).googleTranslateElementInit = googleTranslateElementInit;
    } else {
      googleTranslateElementInit(); // init again if script already loaded
    }

    const observer = new MutationObserver(() => {
      const select = document.querySelector<HTMLSelectElement>(
        "select.goog-te-combo"
      );
      if (select) {
        if (savedLang) {
          select.value = savedLang;
          select.dispatchEvent(new Event("change"));
          document.getElementById("google_translate_element")!.style.display =
            "none";
        } else {
          setShowSelector(true);
          const onChange = (e: Event) => {
            const value = (e.target as HTMLSelectElement).value;
            if (value) {
              localStorage.setItem("preferredLang", value);
              setTimeout(() => {
                document.getElementById(
                  "google_translate_element"
                )!.style.display = "none";
                setShowSelector(false);
              }, 500);
              select.removeEventListener("change", onChange);
            }
          };
          select.addEventListener("change", onChange);
        }
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    const interval = setInterval(() => {
      const isTranslated =
        document.querySelector("html")?.getAttribute("lang") !== "en";
      const banner = document.querySelector(".goog-te-banner-frame");

      if (!banner && savedLang && !isTranslated) {
        localStorage.removeItem("preferredLang");
        setShowSelector(true);
        document.getElementById("google_translate_element")!.style.display =
          "block";
      }
    }, 1000);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  const [sections, setSections] = React.useState([
    {
      title: "Lotteries",
      url: "/app/upComingLotteries",
      id: "0",
      active: false,
    },
    { title: "Live Draws", url: "/app/liveLotteries", id: "1", active: false },
    { title: "Last Draws", url: "/app/replayLottery", id: "2", active: false },
    { title: "Wallet", url: "/app/wallet/MyLottery", id: "3", active: false },
    
    // {
    //   title: "Promotions",
    //   url: "/app/PromotionFreeTicket",
    //   id: "4",
    //   active: false,
    // },
    { title: "ICO", url: "https://presale.gateway2fortune.com/", id: "4", active: false },
    {title: "MDTH", url: "/app/mervsdiamondhunt", id: "5", active: false },
  ]);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorElLang, setAnchorElLang] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElAvatar, setAnchorElAvatar] =
    React.useState<null | HTMLElement>(null);
  const openLang = Boolean(anchorElLang);
  const openAvatar = Boolean(anchorElAvatar);

  const handleClickAvatar = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElAvatar(event.currentTarget);
  };
  const handleCloseAvatar = () => {
    setAnchorElAvatar(null);
  };

  const handleClickLang = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElLang(event.currentTarget);
  };
  const handleCloseLang = () => {
    setAnchorElLang(null);
  };
  const pages = ["Live Lottery", "Lotteries", "Promotions"];
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorElAvatar(null);
    Swal.fire({
      title: "Logout?",
      text: "Are you sure you want to logout?",
      icon: "question",
      showCancelButton: true,
      background: "black",
      color: "#ffff",
      customClass: {
        actions: "swal-actions-class",
        popup: "swal-popup-class",
      },
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      focusConfirm: true,
      allowOutsideClick: false,
      confirmButtonText: "Yes, logout",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setTimeout(() => {
          logout();
        }, 2000);
        Swal.fire({
          icon: "success",
          background: "black",
          color: "#ffff",
          text: "Logged Out! You have been logged out",
        });
      }
    });
  };
  React.useEffect(() => {
    const updatedSections = sections.map((section) => {
      if (section.url === window.location.pathname) {
        return { ...section, active: true };
      } else {
        return { ...section, active: false };
      }
    });
    setSections(updatedSections);
  }, []);

  const handleLinkClick = (sectionId) => {
    const updatedSections = sections.map((section) => {
      if (section.id === sectionId) {
        return { ...section, active: true };
      } else {
        return { ...section, active: false };
      }
    });
    setSections(updatedSections);
  };

  const [sideBarOpen, setSideBarOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setSideBarOpen(newOpen);
  };
  const [scrolled, setScrolled] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
        // Call your function here
        console.log("Scrolled more than 20px");
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <React.Fragment>
      <AppBar
        position="fixed"
        color="default"
        elevation={0}
        sx={{
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          zIndex: "10",
          background: scrolled
            ? "rgba(19, 20, 32, 1)"
            : "rgba(19, 20, 32, 0.4)",
          [theme.breakpoints.down("md")]: {
            position: isSticky ? "relative" : "sticky",
            top: 0,
          },
          minHeight: "fit-content !important",
          paddingBlock: { xs: "0px", md: "3px" },
        }}
        className={isSticky ? "sticky-header-removed" : ""} // Apply Remove sticky class based on prop
      >
        <Toolbar
          sx={{
            flexWrap: "wrap",
            flexFlow: "nowrap",
            zIndex: "1",
            alignItems: "center",
            gap: "10px",
            "justify-content": "space-between",
            minHeight: "fit-content !important",
          }}
        >
          <Box
            sx={{
              display: {
                xs: "flex",
                md: "flex",
              },
              alignItems: "center",
              gap: "10px",
              justifyContent: { lg: "space-between", xs: "start" },
              maxWidth: { xs: "33.33%", lg: "fit-content" },
              flex: { xs: "1 1 100%", lg: "0 1 auto" },
            }}
          >
            <Button
              onClick={toggleDrawer(true)}
              sx={{
                boxSizing: "border-box",
                width: "35px",
                minWidth: "fit-content",
                marginInlineStart: "0px",
                "@media screen and (min-width:992px)": { display: "none" },
              }}
            >
              <DehazeRoundedIcon sx={{ color: "#fff", fontSize: "35px" }} />
            </Button>
            <Box
              className="mervlogo"
              sx={{
                pr: { xs: "0px", sm: "0px", lg: "10px" },
                paddingTop: { xs: "0px", md: "0px" },
              }}
            >
              <Link variant="h3" href="/app">
                <img src={logoCrypto} className="logoImage" alt="logo" />
              </Link>
            </Box>
            <nav
              className="nav-landscape"
              style={{ display: "flex", alignItems: "center", gap: "5px" }}
            >
              {sections.map((section, i) =>
               
                  <Link
                    key={section.title}
                    variant="h3"
                    color="text.primary"
                    href={section.url}
                    textAlign="center"
                    underline="none"
                    sx={{
                      mx: { xs: "0px", lg: "5px" },
                      fontSize: {
                        xs: "10px",
                        sm: "12px",
                        md: "12px",
                        lg: "16px",
                      },
                      color: section.active ? "#ff862d" : "#fff",
                      fontWeight: 900,
                      whiteSpace: "nowrap",
                    }}
                    onClick={() => handleLinkClick(section.id)}
                  >
                    {section.title}
                  </Link>
              
              )}
            </nav>
          </Box>
          <Box
            className="img-landscape-mid-logo"
            sx={{ display: { sm: "block", xs: "none" } }}
          >
            <img
              className="headerPunchLogo"
              src={slogan}
              style={{
                width: "auto",
                maxWidth: "100%",
              }}
              alt="slogan"
            />
          </Box>
          {/* <Box sx={{ flexGrow: 1 }} /> */}
          <Box
            className="try"
            sx={{
              display: { md: "flex", xs: "flex" },
              width: { md: "auto" },
              justifyContent: { lg: "space-between", xs: "flex-end" },
              gap: { xs: "6px", lg: "10px" },
              alignItems: "center",
              maxWidth: { xs: "33.33%", lg: "fit-content" },
              flex: { xs: "1 1 100%", lg: "0 1 auto" },
            }}
          >
            

            <IconButton
              sx={{ p: { xs: "0px", lg: "5px 0px" } }}
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
            >
              <NotificationPopup />
            </IconButton>
            <Link
              href="/app/wallet/MyLottery"
              color={"#ffff"}
              underline="none"
              variant="h3"
              sx={{
                pl: "0px",
                display: "flex",
                alignItems: "center",
                marginLeft: "0px",
                [theme.breakpoints.down("sm")]: {
                  display: "none",
                },
              }}
            >
              <IconButton
                className="landscape-wallet-div"
                color="inherit"
                sx={{
                  backgroundImage: "linear-gradient(111deg, #ff9525, #ff4d4d)",
                  backgroundRepeat: "no-repeat",
                  p: { xs: "6px 10px", lg: "9px 30px" },
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: "18px",
                  "&:hover": {
                    backgroundColor: "#3C37FF",
                  },
                  height: "41px",
                }}
              >
                <img src={wallet} alt="" />

                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: "bold",
                    fontStyle: "normal",
                    color: "rgba(255, 255, 255, 1)",
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={yellowt}
                    style={{
                      height: "auto",
                      width: "17px",
                      marginRight: "4px",
                    }}
                    alt=""
                  />
                  {/* {dataWallet?.data?.data?.walletAmount} */}
                  <CurrencyFormat
                    value={dataWallet?.data?.walletAmount}
                    thousandSeparator={","}
                    displayType={"text"}
                    decimalSeparator={"."}
                  />
                </Typography>
              </IconButton>
            </Link>

            <div className="languageChangeBtn">
              <div
                id="google_translate_element"
                style={{ display: showSelector ? "block" : "none" }}
              />
              {!showSelector && (
                <button
                  onClick={() => {
                    localStorage.removeItem("preferredLang");
                    setShowSelector(true);
                    document.getElementById(
                      "google_translate_element"
                    )!.style.display = "block";
                  }}
                >
                  Change Language
                </button>
              )}
            </div>
            <IconButton
              sx={{ padding: "0px" }}
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-haspopup="true"
              color="inherit"
                // onClick={handleClickAvatar}

            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  "@media screen and (max-width:1298px)": {
                    gap: "6px",
                  },
                  "@media screen and (max-width:767px)": {
                    gap: "5px",
                  },
                }}
              >
                <img
                  alt="avatar"
                  height={30}
                  width={30}
                  src={
                    dataWallet?.data?.userImage
                      ? `${process.env.API_URL_PREFIX}/api/v1/user/uploads/${dataWallet?.data?.userImage}`
                      : `${MervIcon}`
                  }
                  style={{ borderRadius: "50%" }}
                />
                <Button
                  sx={{
                    minWidth: "30px",
                    padding: "0px ",
                    position: "absolute",
                    width: "100% ",
                    height: "100%",
                    opacity: "0",
                  }}
                  id="basic-button-lang-1"
                  aria-controls={openAvatar ? "basic-menu-1" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openAvatar ? "true" : undefined}
                  onClick={handleClickAvatar}
                >
                  {/* <img src={dropdownIcon} alt="login icon"></img> */}
                </Button>

                <Menu
                  id="basic-menu-1"
                  anchorEl={anchorElAvatar}
                  open={openAvatar}
                  onClose={handleCloseAvatar}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem
                    onClick={() => window.location.assign("/app/myAccount")}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: "400",
                        fontStyle: "normal",
                        color: "rgba(255, 255, 255, 0.8)",
                        fontSize: "16px",
                      }}
                    >
                      My Account{" "}
                    </Typography>
                  </MenuItem>
                  <MenuItem
                    onClick={() => window.location.assign("/app/friend")}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: "400",
                        fontStyle: "normal",
                        color: "rgba(255, 255, 255, 0.8)",
                        fontSize: "16px",
                      }}
                    >
                      Friends
                    </Typography>{" "}
                  </MenuItem>
                  <MenuItem onClick={handleLogout}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: "400",
                        fontStyle: "normal",
                        color: "rgba(255, 255, 255, 0.8)",
                        fontSize: "16px",
                      }}
                    >
                      Logout
                    </Typography>{" "}
                  </MenuItem>
                </Menu>
                {/* <img src={dropdownIcon} alt="login icon"></img> */}
              </Box>
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        open={sideBarOpen} // Use `open` instead of `sideBarOpen`
        onClose={toggleDrawer(false)} // `onClose` will toggle the drawer closed
        sx={{
          "& .MuiDrawer-paper": {
            background: "transparent",
            boxShadow: "none",
          },
        }}
      >
        <Box className="sideTray">
          <Box className="sideTarayHeader">
            <Link variant="h3" href="/app">
              <img src={logoCrypto} className="logoImage" alt="" />
            </Link>
            <Link
              href="/app/wallet/MyLottery"
              color={"#ffff"}
              underline="none"
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                backgroundColor: "#3C37FF",
                paddingBlock: "5px",
              }}
            >
              <IconButton
                color="inherit"
                sx={{
                  minWidth: "100px",
                  display: "inline-flex",
                  alignItems: "center",
                  backgroundImage: "linear-gradient(111deg, #ff9525, #ff4d4d)",
                  backgroundRepeat: "no-repeat",
                  p: { xs: "6px 10px", lg: "9px 30px" },
                  gap: "10px",
                  borderRadius: "18px",
                  "&:hover": {
                    backgroundColor: "#3C37FF",
                  },

                }}
              >
                <img src={wallet} alt="wallet" />

                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: "bold",
                    fontStyle: "normal",
                    color: "rgba(255, 255, 255, 0.8)",
                    fontSize: "16px",
                    margin: "0",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={yellowt}
                    style={{
                      height: "auto",
                      width: "16px",
                      marginRight: "3px",
                    }}
                    alt="yellowt"
                  />
                  {/* {dataWallet?.data?.data?.walletAmount} */}
                  <CurrencyFormat
                    value={dataWallet?.data?.walletAmount}
                    thousandSeparator={","}
                    displayType={"text"}
                    decimalSeparator={"."}
                  />

                </Typography>
              </IconButton>
            </Link>
          </Box>
          <Box className="mobileMenu" sx={{ height: "100%" }}>
            <ul className="mobileMenuList">
              {sections.map((section, i) =>
                section.id != "4" ? (
                  <li key={section.id}>
                    <Link
                      key={section.title}
                      variant="h3"
                      color="text.primary"
                      href={section.url}
                      textAlign="center"
                      underline="none"
                      sx={{
                        my: 1,
                        mx: 0.8,
                        // fontSize:'16px',
                        color: section.active ? "#ff862d" : "#fff",
                        fontWeight: 900,
                      }}
                      onClick={() => handleLinkClick(section.id)}
                    >
                      {section.title}
                    </Link>{" "}
                  </li>
                ) : (
                  <></>
                )
              )}
              <li>
                <Link
                  key={sections[4].title}
                  variant="h3"
                  color="text.primary"
                  href={sections[4].url}
                  target="_blank"
                  rel="noopener noreferrer"
                  textAlign="center"
                  underline="none"
                  sx={{
                    my: 1,
                    mx: 0.8,
                    // fontSize:'16px !important',
                    color: sections[4].active ? "#ff862d" : "#fff",
                    fontWeight: 900,
                  }}
                  onClick={() => handleLinkClick(sections[4].id)}
                >
                  {sections[4].title}
                </Link>
              </li>
            </ul>
          </Box>
        </Box>
      </Drawer>
    </React.Fragment>
  );
}
